import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { useCompanies } from "../../hooks/companies";
import AutopilotKpiCard from "./AutopilotKpiCard";

const COLOR_GOOD = "var(--everlog-status-success)";
const COLOR_BAD = "var(--everlog-status-danger)";
const COLOR_STABLE = "var(--everlog-status-neutral)";

const fmtTon = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

const fmtInt = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    maximumFractionDigits: 0,
  });

function getVariationMeta(variation) {
  if (variation == null) {
    return {
      color: COLOR_STABLE,
      text: "Sem comparativo com mês anterior.",
    };
  }

  if (variation > 0) {
    return {
      color: COLOR_BAD,
      text: `▲ ${Math.abs(variation).toFixed(1)}% vs mês anterior`,
    };
  }

  if (variation < 0) {
    return {
      color: COLOR_GOOD,
      text: `▼ ${Math.abs(variation).toFixed(1)}% vs mês anterior`,
    };
  }

  return {
    color: COLOR_STABLE,
    text: "— 0,0% vs mês anterior",
  };
}

const EmissoesCarbonoCard = () => {
  const { empresaId } = useCompanies();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!empresaId) {
      setData(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await api.get("/indicadores/emissoes-carbono/minicard", {
        params: { idEmbarcador: empresaId },
      });
      setData(res.data);
    } catch (requestError) {
      setError("Não foi possível carregar emissões.");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [empresaId]);

  useEffect(() => {
    load();
  }, [load]);

  const variationMeta = getVariationMeta(data?.variacaoPercentual);
  const hasData = Boolean(data);
  const emptyMessage = !empresaId
    ? "Selecione um embarcador para visualizar o resumo de emissões."
    : "Sem dados de emissões disponíveis para o mês atual.";

  return (
    <AutopilotKpiCard
      eyebrow="Sustentabilidade"
      title="Emissões de CO₂"
      description="Resumo mensal do impacto logístico calculado por CTe."
      onClick={() => history.push("/app/flow/indicadores/emissoes-carbono")}
      loading={loading}
      error={error}
      hasData={hasData}
      emptyMessage={emptyMessage}
      primary={
        hasData
          ? {
              label: "Mês atual",
              tag: "CO₂",
              value: fmtTon(data.toneladasMesAtual),
              caption: "t CO₂ calculadas",
              iconClassName: "tim-icons icon-planet",
            }
          : null
      }
      secondaryLines={
        hasData
          ? [
              {
                key: "ctes",
                text: `${fmtInt(data.qtdMesAtual)} CTes considerados`,
              },
              {
                key: "variation",
                text: variationMeta.text,
                color: variationMeta.color,
                fontSize: "0.76rem",
                fontWeight: 600,
              },
            ]
          : []
      }
    />
  );
};

export default EmissoesCarbonoCard;
